// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lazO","option":"styles_option__2PyLF","active":"styles_active__3q718"};